import jsPDF from "jspdf";
import axios from "axios";
import JsBarcode from "jsbarcode";
import Select from "react-select";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import config from "../../../../config/config";
import { Badge } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../../components/Loader/Loader";
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { toastError, toastSuccess } from "../../../../common/Toast";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import { checkUserPermission } from "../../../../common/UserPermission";

let UpdateDataForBarcodeGeneration;

// update user permission data by login user id
export function updateDataForBarcodeGeneration(p_barcodedata) {
  UpdateDataForBarcodeGeneration = p_barcodedata;
}

// return only list of user permission data
export function GetDataForBarcodeGeneration() {
  return UpdateDataForBarcodeGeneration;
}

let barcodesheetdata;

const SearchableDropdown = ({ callback }) => {
  // console.log(customerID, "<===customerId 1155");
  const token = localStorage.getItem("Token");
  const locationID = localStorage.getItem("Location");
  //const Clone = localStorage.getItem("Clone");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [tableData, setTableData] = useState([]);
  const [showRefresh, setShowRefresh] = useState(false);

  // handleChange-
  const handleChange = () => {};

  useEffect(() => {
    // fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue]);

  // Fetch data from an API
  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);

      await axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${inputValue}&iscategory=${0}&customerid=${0}&supplierid=${0}&locationid=${locationID}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response.data.ResponseData.length > 0) {
            if (response != "" && response != null) {
              const data = response.data.ResponseData;

              console.log("suggestions ==>", suggestions);
              // console.log("Search Details ===>", data);

              if (data[0].ItemId > 0) {
                setSuggestions(data);
              }
            }
          }
          setShowRefresh(false);
        })

        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    setShowRefresh(true);
    setInputValue(value);
    if (!value) {
      setSuggestions([]);
    }
  };

  // const handleToast = () => {
  //   if (readonly === true) {
  //     toastError("Please Select a Customer First");
  //   }
  // };

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pCostPrice,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity,
    pRecallPrice,
    pTier1,
    pTier2,
    pTier3,
    pTier4,
    pTier5

    // pItemKitId
  ) => {
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            setSuggestions(data, () => {});

            let tablesDatas = data.map((item) => ({
              SaleItemID: 0,
              ItemId: item.ItemId,
              SaleId: 0,
              UnitPrice: item.UnitPrice,
              // Price: item.UnitPrice,
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: item.VariationQuantity,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              Actualonhand: parseInt(item.VariationQuantity),
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              CategoryName: item.CategoryName,
              CostPrice: item.CostPrice,
              Itemnumber: item.Itemnumber,
              Total: item.UnitPrice,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              RecallPrice: item.RecallPrice,
              Tier1: item.Tier1,
              Tier2: item.Tier2,
              Tier3: item.Tier3,
              Tier4: item.Tier4,
              Tier5: item.Tier5,
            }));

            setTableData([tablesDatas[0]]);
            setSuggestions([]);
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        SaleItemID: 0,
        ItemId: pItemId,
        SaleId: 0,
        UnitPrice: pUnitPrice,
        // Price: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: pVariationQuantity,
        ItemCurrentQuantity: pVariationQuantity, //pItemQuantity,
        Actualonhand: parseInt(pVariationQuantity),
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        Itemkitid: 0,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        CostPrice: pCostPrice,
        Itemnumber: pItemnumber,
        Total: pUnitPrice,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
        RecallPrice: pRecallPrice,
        Tier1: pTier1,
        Tier2: pTier2,
        Tier3: pTier3,
        Tier4: pTier4,
        Tier5: pTier5,
        // ItemKitId: pItemId
      };
      setSuggestions([selectedOption]);
      setTableData([selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
  }, [tableData]);
  console.log(suggestions, "<========suggestions");

  return (
    <div className="container">
      <form>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              {showRefresh ? (
                <i
                  style={{ color: "#FF9F43" }}
                  class="fa fa-refresh fa-spin"
                ></i>
              ) : (
                <Link to="/manage-items">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-pencil-square"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                    <path
                      fillRule="evenodd"
                      d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                    />
                  </svg>
                </Link>
              )}
            </span>

            <input
              type="text"
              className="form-control"
              placeholder="Type item name or scan barcode"
              value={inputValue}
              onChange={handleInputChange}
              // onClick={handleToast}
              // disabled={disabled}
              // readOnly={readonly}
            />
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div className="dropdown">
            <ul
              className="dropdown-menu w-100 show"
              style={{ "max-height": "500px", overflow: "auto" }}
            >
              {suggestions.map((item) => (
                <li
                  className="border-bottom"
                  key={item.ItemId}
                  onClick={() =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.UnitPrice,
                      item.Itemquantity,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.Module,
                      item.CategoryID,
                      item.CategoryName,
                      item.CostPrice,
                      item.Itemnumber,
                      item.Allowaltdescription,
                      item.IsItemserialnumber,
                      item.VariationQuantity,
                      item.RecallPrice,
                      item.Tier1,
                      item.Tier2,
                      item.Tier3,
                      item.Tier4,
                      item.Tier5

                      // item.ItemKitId
                    )
                  }
                >
                  <Link
                    key={item.ItemId}
                    href="#"
                    className="dropdown-item"
                    data-name={item.ItemName?.toLowerCase()}
                  >
                    <img
                      src={item.ImageName}
                      onError={(e) => {
                        e.currentTarget.src =
                          "https://th.bing.com/th/id/OIP.ADcGkW6WTfq2zu8yoY8vlgHaHa?w=197&h=197&c=7&r=0&o=5&pid=1.7";
                      }}
                      alt={item.ItemName}
                      className="img-thumbnail rounded-circle m-2"
                      width="55px"
                      height="55px"
                    />
                    <div className="customer-info">
                      <strong className="name word-break-data">
                        {item.ItemName}{" "}
                        {item.VariationName ? `(${item.VariationName})` : ""}
                        <Badge
                          className="ml-auto"
                          variant="primary"
                          style={{ position: "absolute", right: "5px" }}
                        >
                          {item.Module}
                        </Badge>
                      </strong>
                      <div>
                        {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} |
                        Promo Price: {parseFloat(item.PromoPrice).toFixed(2)}| */}
                        {/* Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                        Unit Price: {parseFloat(item.UnitPrice).toFixed(2)} |
                        Qty: {parseInt(item.VariationQuantity)}
                      </div>
                      <div>Categories: {item.CategoryName}</div>
                      {/* Add any other customer details here */}
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </form>
    </div>
  );
};

const BarcodeLabel = (barcodeLabel) => {
  function barcodeLabelPopup() {
    barcodeLabel();
    const token = localStorage.getItem("Token");
  }

  const barcodeRefs = useRef([]);
  const [selectedId, setSelectedId] = useState([]);
  const [value, setValue] = useState([0]);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      var g = document.getElementsByTagName(barcodeRef);
      const dataItemId = barcodeRef?.getAttribute("data-itemid");
      const barcodeValue = dataItemId;
      // const barcodeValue = `${index}`;
      const paddedBarcodeValue = barcodeValue?.padStart(data.zeroFill, "0"); // Zerofill at the barcode

      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 0,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  useEffect(() => {
    // setTimeout(function () {
    generateBarcodes(barcodesheetdata);
    // }, 2000);
  }, [value]);

  const refreshpage = () => {
    window.location.reload();
  };

  const downloadPdf = () => {
    generateBarcodes(barcodesheetdata);
    const pdf = new jsPDF();

    let yOffset = 10; // Initial y offset value
    let pageHeight = pdf.internal.pageSize.getHeight() - 10; // Get the page height

    barcodeRefs.current.forEach((barcodeRef, index) => {
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");

      const barcodeHeight = data.height; // Use 'data.height' instead of 'value * data.height'

      if (yOffset + barcodeHeight > pageHeight) {
        pdf.addPage(); // Add a new page if the barcode exceeds the remaining space on the current page
        yOffset = 10; // Reset the y offset for the new page
        pageHeight = pdf.internal.pageSize.getHeight() - 10; // Get the updated page height
      }

      // Print "Sonar POS" text above the barcode
      pdf.setFontSize(10);
      pdf.text("Sonar POS", 13, yOffset + 9);

      // Print the barcode image
      pdf.addImage(imgData, "PNG", 10, yOffset + 10); // Adjust the y coordinate as needed

      // Print "UnitPrice" and "VariationName" below the barcode
      const item = barcodesheetdata[index - 1];
      pdf.setFontSize(8);
      pdf.text(
        `$${parseFloat(item?.UnitPrice).toFixed(2)} ${item?.VariationName}`,
        8,
        yOffset + barcodeHeight + 4
      ); // Adjust the y coordinate as needed

      yOffset += barcodeHeight + 25; // Increment the y offset for the next barcode without spacing
    });

    pdf.save("barcodes.pdf");
    // window.location.reload(true);
  };

  console.log("barcodeSheetData::>>", barcodesheetdata, barcodeRefs);

  return (
    <>
      <div
        className="modal fade"
        id="BarcodeLabelModal"
        tabIndex={-1}
        //   aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-m modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Number of labels to skip</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <input
                    type="number"
                    className="form-control mb-4"
                    placeholder="Number of labels to skip"
                    onChange={(event) => setValue(event.target.value)}
                  ></input>
                </div>
                <div className="modal-footer justify-content-center">
                  <Link
                    to="#"
                    className="btn btn-primary btn-md me-1 form-control text-align-center"
                    data-bs-dismiss="modal"
                    onClick={() => downloadPdf()}
                  >
                    Submit{" "}
                  </Link>
                </div>
                <div id="barcode-output" className="text-center">
                  {barcodesheetdata?.map((item, index) => (
                    <div key={item}>
                      <div key={item.AutoIncrementId} className="mb-4">
                        <div>Sonar POS</div>
                        <canvas
                          data-itemid={item.Id}
                          data-name={item.AutoIncrementId}
                          ref={(el) =>
                            (barcodeRefs.current[item.AutoIncrementId] = el)
                          }
                          id={`barcode-${item.AutoIncrementId}`}
                        />
                        <div>
                          ${parseFloat(item.UnitPrice).toFixed(2)}
                          {item.VariationName}
                          {/* &nbsp;&nbsp; */}
                        </div>
                        {/* <div></div> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const CloseFinishCountAndUpdateInventory = (
  { handleSubmit },
  closeFinishCountAndUpdateInventory
) => {
  function closeFinishCountAndUpdateInventoryPopUp() {
    closeFinishCountAndUpdateInventory();
    const token = localStorage.getItem("Token");
  }
  return (
    <>
      <div
        className="modal fade"
        id="CloseFinishCountAndUpdateInventoryModal"
        tabIndex={-1}
        //   aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-m modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Close Finish Count And Update Inventory
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h6>Are you sure you want to finish the inventory count?</h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSubmit("1");
                  closeFinishCountAndUpdateInventoryPopUp();
                }}
              >
                Ok
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const CloseFinishCountAndDoNotUpdateInventory = (
  { handleSubmit },
  closeFinishCountAndDoNotUpdateInventory
) => {
  function closeFinishCountAndDoNotUpdateInventoryPopUp() {
    closeFinishCountAndDoNotUpdateInventory();
    const token = localStorage.getItem("Token");
  }
  return (
    <>
      <div
        className="modal fade"
        id="CloseFinishCountAndDoNotUpdateInventoryModal"
        tabIndex={-1}
        //   aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-m modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                Close Finish Count And Do Not Update Inventory
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h6>Are you sure you want to finish the inventory count?</h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                to="#"
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSubmit("2");

                  closeFinishCountAndDoNotUpdateInventoryPopUp();
                }}
              >
                Ok
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const ContinueCountLater = ({ handleSubmit }, continueCountLater) => {
  function continueCountLaterPopUp() {
    continueCountLater();
    const token = localStorage.getItem("Token");
  }
  return (
    <>
      <div
        className="modal fade"
        id="ContinueCountLaterModal"
        tabIndex={-1}
        //   aria-labelledby="delete"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-m modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Continue Count Later</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 text-center">
                  <h6>Are you sure you want to finish the inventory count?</h6>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-center">
              <Link
                className="btn btn-primary btn-md me-1"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleSubmit("3");
                  continueCountLaterPopUp();
                }}
              >
                Ok
              </Link>
              <Link
                to="#"
                className="btn btn-dark btn-md me-1"
                data-bs-dismiss="modal"
              >
                Cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const NewInventoryCount = (props) => {
  const barcodeRefs = useRef([]);
  const paramObject = useParams();
  const Id = localStorage.getItem("ID");
  const token = localStorage.getItem("Token");
  // const [formValues, setFormValues] = useState();
  const [stateNew, setStateNew] = useState([]);
  const [loading, setLoading] = useState(false);
  const [select, setSelect] = useState("Receive");
  const locationId = localStorage.getItem("Location");
  const [changeCount, setChangeCount] = useState([0]);
  const [changeComment, setChangeComment] = useState([0]);
  const [checkStatus, setCheckStatus] = useState(false);
  const [statusData, setStatusData] = useState(0);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });
  const [depositToAccount, setDepositToAccount] = useState([]);
  console.log("depositToAccount 785", depositToAccount);
  const [supoptions, setSupOptions] = useState([]);
  // const []

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  const handleCountChange = (event, index) => {
    let indexCount = [...changeCount];
    indexCount[index] = event.target.value;
    // console.log(index, indexCount);

    setChangeCount(indexCount);
    // console.log("changeCount ==> ", changeCount);
  };

  const handleCommentChange = (event, index) => {
    let indexComment = [...changeComment];
    indexComment[index] = event.target.value;
    // console.log(index, indexComment);

    setChangeComment(indexComment);
    // console.log("changeComment ==> ", changeComment);
  };
  const navigate = useNavigate();
  const handleSubmit = (Status) => {
    // let paramObject.id;
    if (!paramObject.id) {
      setLoading(true);
      axios
        .post(
          `${config.itemsBaseUrl}/items/countinventoryupsert`,
          {
            id: 0,
            loginuserid: Id,
            locationid: locationId,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
            // toastSuccess(SUCCESS_MESSAGE);
            for (let i = 0; i < stateNew.length; i++) {
              stateNew[i].Counts = changeCount[i];
              stateNew[i].Comments = changeComment[i];
              stateNew[i].AccountId = stateNew[i].AccountId;
              stateNew[i].SupplierId = stateNew[i].SupplierId;
            }
            if (Status == "1") {
              let CountInventoryUpdate = stateNew.filter(function (
                countInventoryUpdate
              ) {
                return countInventoryUpdate.VariationName !== "";
              });

              const countinventoryupdateobj = {};
              countinventoryupdateobj.importDataXML = CountInventoryUpdate;
              let countinventoryupdatejsonstring = JSON.stringify(
                countinventoryupdateobj
              );

              localStorage.setItem("New", JSON.stringify(stateNew));
              axios
                .post(
                  `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
                  {
                    xmlImportData: countinventoryupdatejsonstring,
                    inventoryCountId: res.data.ResponseID,
                    locationId: locationId,
                    status: Status,
                    loginUserId: Id,
                  },
                  {
                    headers: {
                      "Content-Type": "application/json;charset=UTF-8",
                      "Access-Control-Allow-Origin": "*",
                      Authorization: token,
                    },
                  }
                )
                .then((res) => {
                  // console.log("res 1 ==> ", res);
                  setLoading(true);
                  if (res.data.ResponseCode === "SUCCESS") {
                    toastSuccess(SUCCESS_MESSAGE);
                    navigate(`/new-inventory-count/${res.data.ResponseID}`);
                    setStatusData(1);
                  } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseID === -1
                  ) {
                    toastError("Name" + ALREADY_EXIST);
                  } else {
                    toastError(ERROR_MESSAGE);
                  }
                  setLoading(false);
                  // window.location.href = window.location.href;
                })
                .catch((error) => {
                  setLoading(false);
                  // console.log("error: ", error);
                });
            } else if (Status == "2") {
              let CountInventoryUpdate = stateNew.filter(function (
                countInventoryUpdate
              ) {
                return countInventoryUpdate.VariationName !== "";
              });

              const countinventoryupdateobj = {};
              countinventoryupdateobj.importDataXML = CountInventoryUpdate;
              let countinventoryupdatejsonstring = JSON.stringify(
                countinventoryupdateobj
              );

              axios
                .post(
                  `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
                  {
                    xmlImportData: countinventoryupdatejsonstring,
                    inventoryCountId: res.data.ResponseID,
                    locationId: locationId,
                    status: Status,
                    loginUserId: Id,
                  },
                  {
                    headers: {
                      "Content-Type": "application/json;charset=UTF-8",
                      "Access-Control-Allow-Origin": "*",
                      Authorization: token,
                    },
                  }
                )
                .then((res) => {
                  // console.log("res 2 ==> ", res);
                  setLoading(true);
                  if (res.data.ResponseCode === "SUCCESS") {
                    toastSuccess(SUCCESS_MESSAGE);
                    navigate(`/new-inventory-count/${res.data.ResponseID}`);
                    setStatusData(2);
                  } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseID === -1
                  ) {
                    toastError("Name" + ALREADY_EXIST);
                  } else {
                    toastError(ERROR_MESSAGE);
                  }
                  // window.location.href = window.location.href;
                  setLoading(false);
                })
                .catch((error) => {
                  setLoading(false);
                  // console.log("error: ", error);
                });
            } else if (Status == "3") {
              let CountInventoryUpdate = stateNew.filter(function (
                countInventoryUpdate
              ) {
                return countInventoryUpdate.VariationName !== "";
              });

              const countinventoryupdateobj = {};
              countinventoryupdateobj.importDataXML = CountInventoryUpdate;
              let countinventoryupdatejsonstring = JSON.stringify(
                countinventoryupdateobj
              );

              axios
                .post(
                  `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
                  {
                    xmlImportData: countinventoryupdatejsonstring,
                    inventoryCountId: res.data.ResponseID,
                    locationId: locationId,
                    status: Status,
                    loginUserId: Id,
                  },
                  {
                    headers: {
                      "Content-Type": "application/json;charset=UTF-8",
                      "Access-Control-Allow-Origin": "*",
                      Authorization: token,
                    },
                  }
                )
                .then((res) => {
                  // console.log("res 3 ==> ", res);
                  setLoading(true);
                  if (
                    res.data.ResponseCode === "SUCCESS" &&
                    res.data.ResponseID > 0
                  ) {
                    toastSuccess(SUCCESS_MESSAGE);
                    navigate(`/new-inventory-count/${res.data.ResponseID}`);
                    setStatusData(3);
                  } else if (
                    res.data.ResponseCode === "ERROR" &&
                    res.data.ResponseID === -1
                  ) {
                    toastError("Name" + ALREADY_EXIST);
                  } else {
                    toastError(ERROR_MESSAGE);
                  }
                  // window.location.href = window.location.href;
                  setLoading(false);
                })
                .catch((error) => {
                  setLoading(false);
                });
            } else {
              console.log("No Condition matched");
            }
            // console.log(res.data.ResponseID);
            // paramObject.id = res.data.ResponseID;
            // navigate(`/new-inventory-count/${res.data.ResponseID}`);
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError("Name" + ALREADY_EXIST);
          } else {
            toastError(ERROR_MESSAGE);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          // console.log("error: ", error);
        });
    } else {
      for (let i = 0; i < stateNew.length; i++) {
        stateNew[i].Counts = changeCount[i];
        stateNew[i].Comments = changeComment[i];
      }
      if (Status == "1") {
        let CountInventoryUpdate = stateNew.filter(function (
          countInventoryUpdate
        ) {
          return countInventoryUpdate.VariationName !== "";
        });

        const countinventoryupdateobj = {};
        countinventoryupdateobj.importDataXML = CountInventoryUpdate;
        let countinventoryupdatejsonstring = JSON.stringify(
          countinventoryupdateobj
        );

        axios
          .post(
            `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
            {
              xmlImportData: countinventoryupdatejsonstring,
              inventoryCountId: paramObject.id,
              locationId: locationId,
              status: Status,
              loginUserId: Id,
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log("res 1 ==> ", res);
            setLoading(true);
            if (res.data.ResponseCode === "SUCCESS") {
              toastSuccess(SUCCESS_MESSAGE);
              navigate(`/new-inventory-count/${paramObject.id}`);
            } else if (
              res.data.ResponseCode === "ERROR" &&
              res.data.ResponseID === -1
            ) {
              toastError("Name" + ALREADY_EXIST);
            } else {
              toastError(ERROR_MESSAGE);
            }
            setLoading(false);
            window.location.href = window.location.href;
          })
          .catch((error) => {
            setLoading(false);
            // console.log("error: ", error);
          });
      } else if (Status == "2") {
        let CountInventoryUpdate = stateNew.filter(function (
          countInventoryUpdate
        ) {
          return countInventoryUpdate.VariationName !== "";
        });

        const countinventoryupdateobj = {};
        countinventoryupdateobj.importDataXML = CountInventoryUpdate;
        let countinventoryupdatejsonstring = JSON.stringify(
          countinventoryupdateobj
        );

        axios
          .post(
            `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
            {
              xmlImportData: countinventoryupdatejsonstring,
              inventoryCountId: paramObject.id,
              locationId: locationId,
              status: Status,
              loginUserId: Id,
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log("res 2 ==> ", res);
            setLoading(true);
            if (res.data.ResponseCode === "SUCCESS") {
              toastSuccess(SUCCESS_MESSAGE);
              navigate(`/new-inventory-count/${paramObject.id}`);
            } else if (
              res.data.ResponseCode === "ERROR" &&
              res.data.ResponseID === -1
            ) {
              toastError("Name" + ALREADY_EXIST);
            } else {
              toastError(ERROR_MESSAGE);
            }
            window.location.href = window.location.href;
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
            // console.log("error: ", error);
          });
      } else if (Status == "3") {
        let CountInventoryUpdate = stateNew.filter(function (
          countInventoryUpdate
        ) {
          return countInventoryUpdate.VariationName !== "";
        });

        const countinventoryupdateobj = {};
        countinventoryupdateobj.importDataXML = CountInventoryUpdate;
        let countinventoryupdatejsonstring = JSON.stringify(
          countinventoryupdateobj
        );

        axios
          .post(
            `${config.itemsBaseUrl}/items/countitemsinventoryfinish`,
            {
              xmlImportData: countinventoryupdatejsonstring,
              inventoryCountId: paramObject.id,
              locationId: locationId,
              status: Status,
              loginUserId: Id,
            },
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            // console.log("res 3 ==> ", res);
            setLoading(true);
            if (
              res.data.ResponseCode === "SUCCESS" &&
              res.data.ResponseID > 0
            ) {
              toastSuccess(SUCCESS_MESSAGE);
              navigate(`/new-inventory-count/${paramObject.id}`);
            } else if (
              res.data.ResponseCode === "ERROR" &&
              res.data.ResponseID === -1
            ) {
              toastError("Name" + ALREADY_EXIST);
            } else {
              toastError(ERROR_MESSAGE);
            }
            window.location.href = window.location.href;
            setLoading(false);
          })
          .catch((error) => {
            setLoading(false);
          });
      } else {
        console.log("No Condition matched");
      }
    }
  };

  const callback = (payload) => {
    if (payload != undefined && payload.length > 0) {
      const newItem = { ...payload[payload.length - 1] };
      const existingItemIndex = stateNew.findIndex(
        (item) =>
          item.VariationName === newItem.VariationName &&
          item.VariationId === newItem.VariationId
      );

      if (existingItemIndex !== -1) {
        const existingItem = stateNew[existingItemIndex];

        existingItem.itemquantity = existingItem.itemquantity + 1;

        const updatedDataNew = [...stateNew];
        updatedDataNew[existingItemIndex] = existingItem;

        setStateNew(updatedDataNew);
      } else {
        setStateNew([...stateNew, newItem]);
      }
    }
    // setStateNew(payload);
  };
  console.log("stateNew ==> ", stateNew);
  const handlebarcodesheet = () => {
    let transformedArray = [];
    stateNew.forEach((obj) => {
      for (let i = 0; i < obj.Counts; i++) {
        const newObj = {
          AutoIncrementId: transformedArray.length + 1,
          Id: obj.Id,
          VariationName: obj.VariationName,
          ItemId: obj.ItemId,
          CostPrice: obj.CostPrice,
          UnitPrice: obj.UnitPrice,
        };
        transformedArray.push(newObj);
      }
    });

    barcodesheetdata = transformedArray;

    // setFormValues(transformedArray);
  };

  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      itemcountinventoryid: pID,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  console.log("stateNew 1270", stateNew);
  useEffect(() => {
    if (paramObject.id) {
      setLoading(true);
      axios
        .get(
          `${config.itemsBaseUrl}/items/countinventoryfindbyid?inventorycountid=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          setStateNew(res.data.ResponseData.CountInventory);
          callback(stateNew);
          setCheckStatus(res.data.ResponseData.Status == 3 ? true : false);
          console.log("first", res.data.ResponseData);
          setStatusData(res.data.ResponseData.Status);

          res.data.ResponseData.CountInventory?.map((data, index) => {
            changeCount[index] = data.Counts;
          });
          res.data.ResponseData.CountInventory.map((data, index) => {
            changeComment[index] = data.Comments;
          });
          setLoading(false);
        })
        .catch((err) => {
          console.log("Error ==> ", err);
          setLoading(false);
        });
      setLoading(false);
    }
  }, [props, paramObject.id > 0]);

  const location = useLocation();
  const sharedState = location?.state ? location?.state.dataToSend : "";
  // const newData = stateNew.concat(sharedState);
  console.log("Locationnnnnn", sharedState);

  // useEffect(() => {
  //   // const newData = [...stateNew, ...sharedState];

  //   if (stateNew && sharedState) {
  //     const mappedReceivingItems = sharedState?.map((item) => {
  //       const mappedItem = {
  //         ActualOnHand: item.ItemActualOnHand,
  //         Comments: "",
  //         CostPrice: item.CostPrice,
  //         Counts: item.Count,
  //         Id: item.Id,
  //         InventoryCountId: paramObject.id,
  //         ItemId: item.ItemId,
  //         UnitPrice: item.UnitPrice,
  //         VariationId: item.itemVariationId,
  //         VariationName: item.ItemName,
  //       };
  //       return mappedItem;
  //     });
  //     const combinedArray = [...stateNew, ...mappedReceivingItems];
  //     setStateNew(combinedArray);
  //   }
  // }, [sharedState]);
  useEffect(() => {
    if (stateNew && sharedState) {
      const mappedReceivingItems = sharedState?.map((item) => {
        const mappedItem = {
          ActualOnHand: item.ItemActualOnHand,
          Comments: "",
          CostPrice: item.CostPrice,
          Counts: item.Count,
          Id: item.Id,
          InventoryCountId: paramObject.id,
          ItemId: item.ItemId,
          UnitPrice: item.UnitPrice,
          VariationId: item.itemVariationId,
          VariationName: item.ItemName,
        };
        return mappedItem;
      });
      const combinedArray = [...stateNew, ...mappedReceivingItems];
      setStateNew((prev) => [...prev, ...mappedReceivingItems]);
    }
  }, [sharedState]);

  useEffect(() => {
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("ChartOfAccountDropdown", res.data.ResponseData);
        const mappedReceivingItems = res.data.ResponseData.map((item) => {
          const mappedItem = {
            label: item.Name,
            value: item.ID,
            Amount: item.Amount,
          };
          return mappedItem;
        });
        // setStateNew(mappedReceivingItems);
        setDepositToAccount(mappedReceivingItems);
        // return res;
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/supplierdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        setSupOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const options = supoptions.map((option) => ({
    value: option.ID,
    // label: option.FirstName,
    label : option.CompanyName + " ("+option.FirstName +" " + option.LastName+")",
    email: option.Email,
    address: option.Address,
    balance: option.Balance,
    image: option.Image,
  }));

  console.log("options 1410", options);

  const handleChangeInput = (event, index, fieldName) => {
    // console.log("inventory count 1408", event);
    if (fieldName == "InventoryAdjusmentAccount") {
      setStateNew((prev) => {
        const updatedData = [...prev];
        updatedData[index]["AccountId"] = event?.value;
        return updatedData;
      });
      console.log(event?.value, index, fieldName, "inventory count 456");
    } else if (fieldName == "Supplier") {
      setStateNew((prev) => {
        const updatedData = [...prev];
        updatedData[index]["SupplierId"] = event?.value;
        return updatedData;
      });
      console.log(event?.value, index, fieldName, "inventory count 456");
    } else if (fieldName == "EntryDate") {
      console.log(
        event?.target?.value,
        index,
        fieldName,
        "inventory count 456"
      );
    } else if (fieldName == "RefrenceNo") {
      console.log(
        event?.target?.value,
        index,
        fieldName,
        "inventory count 456"
      );
    }
  };

  console.log("stateNew, depositToAccount 1447", stateNew, depositToAccount);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>Count Inventory</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/item-count-invetory">Count Inventory</Link>
                </li>
                <li className="breadcrumb-item active">New Inventory Count</li>
              </ul>
            </div>
          </div>
          <div className="col-md-12 page-button mb-3">
            <div className="d-flex flex-wrap">
              {/* Items Not Counted & In Stock */}
              <div className="p-2">
                <Link
                  className="btn btn-sm btn-primary"
                  to={`/item-not-counted-and-in-stock/${paramObject.id}`}
                >
                  Items Not Counted &amp; In Stock
                </Link>
              </div>
              {/* Items Not Counted */}
              <div className="p-2">
                <Link
                  className="btn btn-sm btn-primary"
                  to={`/item-not-counted/${paramObject.id}`}
                >
                  Items Not Counted
                </Link>
              </div>
              {/* Barcode Labels */}
              <div className="p-2">
                <Link
                  className="btn btn-sm btn-success"
                  to={`/item-count-inventory-barcode-label/${paramObject.id}`}
                  onClick={() => updateDataForBarcodeGeneration(stateNew)}
                >
                  Barcode Labels
                </Link>
              </div>
              {/* Barcode Sheet */}
              <div className="p-2">
                <button
                  className="btn btn-sm btn-success"
                  data-bs-toggle="modal"
                  data-bs-target="#BarcodeLabelModal"
                  onClick={() => handlebarcodesheet()}
                >
                  Barcode Sheet
                </button>
                <BarcodeLabel />
              </div>
              {/* Excel Import Button */}
              <div className="p-2">
                <Link
                  className="btn btn-sm btn-success"
                  to={`/item-excel-import-count/${paramObject.id}`}
                >
                  Excel Import
                </Link>
              </div>
              {/* Search Button */}
              {/* <div className="p-2">
                <Link className="btn btn-info" to="#">
                  Search
                </Link>
              </div> */}
              {/* Search Text Field */}
              {/* <div className="p-2">
                <div className="col-md-12">
                  <input
                    type="search"
                    placeholder="Search By Item Name"
                    className="search-btn form-control"
                  />
                </div>
              </div>
              <div className="p-2">
                <input
                  type="date"
                  className="form-control"
                  id="EntryDate"
                  name="EntryDate"
                  onChange={(event, index) =>
                    handleChangeInput(event, index, "EntryDate")
                  }
                  // value={Moment(inventoryadjustment.AdjusmentDate).format(
                  //   "YYYY-MM-DD"
                  // )}
                />
              </div>

              <div className="p-2">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter No"
                    name="ReferenceNo"
                    // defaultValue={inventoryadjustment.Refrenceno}
                    onChange={(event, index) =>
                      handleChangeInput(event, index, "RefrenceNo")
                    }
                  />
                </div>
              </div> */}
            </div>
          </div>

          {/* Card for listing count inventory */}
          {checkStatus ? (
            <>
              <div className="card">
                {/* Card Header {Count Inventory} */}
                <div className="card-header">
                  <div className="row">
                    <div className="col-md-6">
                      {/* <h5 className="fw-bold mt-3">New Inventory Count</h5> */}
                      <div className="col-md-12">
                        <div className="input-group flex-nowrap col-md-8">
                          <SearchableDropdown
                            callback={callback}
                            changeCount={changeCount}
                          />
                          {/* <Link className="btn btn-info" to="#">
                            Search
                          </Link> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : !paramObject.id ? (
            <div className="card">
              {/* Card Header {Count Inventory} */}
              <div className="card-header">
                <div className="row">
                  <div className="col-md-6">
                    {/* <h5 className="fw-bold mt-3">New Inventory Count</h5> */}
                    <div className="col-md-12">
                      <div className="input-group flex-nowrap col-md-8">
                        <SearchableDropdown
                          callback={callback}
                          changeCount={changeCount}
                        />
                        {/* <Link className="btn btn-info" to="#">
                          Search
                        </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="card">
            <div className="card-body">
              <table className="table table-striped custom-table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Item Name</th>
                    <th>Count</th>
                    <th>Quantity</th>
                    <th>Comment</th>
                    {checkUserPermission("show-cost-price") && <th>Cost</th>}
                    <th>Selling</th>
                    <th>Total Cost</th>
                    <th>Total Selling</th>
                    <th style={{ width: "20%" }}>Account</th>
                    <th style={{ width: "20%" }}>Supplier</th>
                    {checkStatus && <th>Delete</th>}
                  </tr>
                </thead>
                <tbody>
                  {stateNew?.map((data, index) => {
                    return (
                      <>
                        <tr key={index}>
                          <td>{data.ItemId}</td>
                          <td>{data.VariationName}</td>
                          <td className="col-md-1">
                            <input
                              type="number"
                              defaultValue={data.Counts}
                              onChange={(event) =>
                                handleCountChange(event, index)
                              }
                              className="form-control form-control-sm"
                              readOnly={
                                checkStatus === true
                                  ? null
                                  : !paramObject.id
                                  ? null
                                  : "readonly"
                              }
                            />
                          </td>
                          <td>
                            {parseFloat(
                              data.Actualonhand
                                ? data.Actualonhand
                                : data.ActualOnHand
                                ? data.ActualOnHand
                                : 0
                            )}
                          </td>
                          <td className="col-md-1">
                            <input
                              type="text"
                              defaultValue={data.Comments}
                              className="form-control form-control-sm"
                              onChange={(event) =>
                                handleCommentChange(event, index)
                              }
                              readOnly={
                                checkStatus === true
                                  ? null
                                  : !paramObject.id
                                  ? null
                                  : "readonly"
                              }
                            />
                          </td>
                          {checkUserPermission("show-cost-price") && (
                            <td>
                              {parseFloat(
                                data.CostPrice ? data.CostPrice : 0
                              ).toFixed(2)}
                            </td>
                          )}

                          <td>
                            {parseFloat(
                              data.UnitPrice ? data.UnitPrice : 0
                            ).toFixed(2)}
                          </td>
                          <td>
                            {parseFloat(
                              data.CostPrice * changeCount[index]
                                ? data.CostPrice * changeCount[index]
                                : 0
                            ).toFixed(2)}
                          </td>
                          <td>
                            {parseFloat(
                              data.UnitPrice * changeCount[index]
                                ? data.UnitPrice * changeCount[index]
                                : 0
                            ).toFixed(2)}
                          </td>
                          <td>
                            <Select
                              className="z-index:2 custom-search-select"
                              options={depositToAccount}
                              value={depositToAccount?.filter(
                                (el) => el.value === data?.AccountId
                              )}
                              placeholder="Select an Account"
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={selectStyles}
                              id="InventoryAdjusmentAccount"
                              name="InventoryAdjusmentAccount"
                              onChange={(event) =>
                                handleChangeInput(
                                  event,
                                  index,
                                  "InventoryAdjusmentAccount"
                                )
                              }
                            />
                          </td>
                          <td>
                            <Select
                            className="custom-search-select"
                              options={options}
                              value={options?.filter(
                                (el) => el.value === data?.SupplierId
                              )}
                              placeholder="Select a Supplier"
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              styles={selectStyles}
                              id="Supplier"
                              name="Supplier"
                              onChange={(event) =>
                                handleChangeInput(event, index, "Supplier")
                              }
                            />
                          </td>
                          {checkStatus && (
                            <td>
                              <Link
                                className="confirm-text"
                                to="#"
                                title="Delete"
                                data-bs-toggle="modal"
                                data-bs-target="#DeleteConfirmationModal"
                                onClick={() => handleDeletePopup(data.Id)}
                              >
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  data-bs-toggle="tooltip"
                                  title="Delete"
                                ></i>
                              </Link>
                            </td>
                          )}
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          {/* {checkStatus && (
            <div className="d-flex flex-wrap justify-content-left align-items-center">
              <div className="m-2">
                <button
                  className="btn btn-danger w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndUpdateInventoryModal"
                >
                  Close / Finish Count and Update Inventory
                </button>
                <CloseFinishCountAndUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndDoNotUpdateInventoryModal"
                >
                  Close / Finish Count and Do Not Update Inventory
                </button>
                <CloseFinishCountAndDoNotUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-info w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#ContinueCountLaterModal"
                >
                  Continue Count Later
                </button>
                <ContinueCountLater handleSubmit={handleSubmit} />
              </div>
            </div>
          )} */}
          {statusData == 3 ? (
            <div className="d-flex flex-wrap justify-content-left align-items-center">
              <div className="m-2">
                <button
                  className="btn btn-danger w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndUpdateInventoryModal"
                >
                  Close / Finish Count and Update Inventory
                </button>
                <CloseFinishCountAndUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndDoNotUpdateInventoryModal"
                >
                  Close / Finish Count and Do Not Update Inventory
                </button>
                <CloseFinishCountAndDoNotUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-info w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#ContinueCountLaterModal"
                >
                  Continue Count Later
                </button>
                <ContinueCountLater handleSubmit={handleSubmit} />
              </div>
            </div>
          ) : statusData == 2 ? (
            <div className="d-flex flex-wrap justify-content-left align-items-center">
              <div className="m-2">
                <button
                  className="btn btn-danger w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndUpdateInventoryModal"
                >
                  Close / Finish Count and Update Inventory
                </button>
                <CloseFinishCountAndUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndDoNotUpdateInventoryModal"
                >
                  Close / Finish Count and Do Not Update Inventory
                </button>
                <CloseFinishCountAndDoNotUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
            </div>
          ) : !paramObject.id ? (
            <div className="d-flex flex-wrap justify-content-left align-items-center">
              <div className="m-2">
                <button
                  className="btn btn-danger w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndUpdateInventoryModal"
                >
                  Close / Finish Count and Update Inventory
                </button>
                <CloseFinishCountAndUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-primary w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#CloseFinishCountAndDoNotUpdateInventoryModal"
                >
                  Close / Finish Count and Do Not Update Inventory
                </button>
                <CloseFinishCountAndDoNotUpdateInventory
                  handleSubmit={handleSubmit}
                />
              </div>
              <div className="m-2">
                <button
                  className="btn btn-info w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#ContinueCountLaterModal"
                >
                  Continue Count Later
                </button>
                <ContinueCountLater handleSubmit={handleSubmit} />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.itemsBaseUrl}/items/itemcountinventorydeletebyid`}
      />
    </>
  );
};

export default NewInventoryCount;
